export default {
  type: "Linehaul Type",
  not_especified: "--",
};
